import { useTheme } from '@emotion/react'

export const useDownloadCashAppUrl = (): string => {
  const theme = useTheme()
  const removeHexCode = (hex: string) => hex.replace('#', '')

  const backgroundColor = removeHexCode(theme.arcadeColors.semantic.backgroundApp)
  const foregroundColor = removeHexCode(theme.arcadeColors.semantic.backgroundInverse)
  const logoColor = removeHexCode(theme.arcadeColors.semantic.iconBrand)

  return `https://cash.app/qr/download?bg=${backgroundColor}&fg=${foregroundColor}&logoColor=${logoColor}&format=svg`
}
